import { getCurrentDate } from "../../../cpcoc/currentDate";
export function getScheduleToday(worshipTimes) {
    const now = getCurrentDate();
    let scheduleToday = false;
    for (let i = 0, l = worshipTimes.length; i < l; i++) {
        const event = worshipTimes[i];
        if (now.getDate() === event.date.getDate()) {
            scheduleToday = event;
            break;
        }
    }
    return scheduleToday;
}
